<template>
  <div class="playVideoBox" v-show="show_video_pop">
    <div class="videoOxb">
      <video class="videoOxbVid" controls :src="video_play_url"></video>
      <div class="closeOrOpen" @click="close()">
        <img src="/static/img/closeLoginIc.png" class="closeIconBtn" alt="">
      </div>
    </div>

  </div>
</template>

<script>
export default {
  methods: {
    close() {
      let vid = document.querySelector('.videoOxbVid')
      vid.pause()
      // payKeStore.showVideoPop(false)
      this.$store.commit('showVideoPop', false)

    },
    playVid() {
      setTimeout(() => {
        let vid = document.querySelector('.videoOxbVid')
        vid.play()
      });
    }
  },
  computed: {
    show_video_pop() {
      return this.$store.state.show_video_pop
    },
    video_play_url() {
      return this.$store.state.video_play_url
    }
  }

}
</script>

<style lang="scss" scoped>
.playVideoBox {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;

  .videoOxb {
    position: relative;
    width: calc(100% - 80px);
    height: auto;
    border:5px solid #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    .videoOxbVid {
      width: 100%;
      height: 100%;
    }

    .closeOrOpen {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: #fff;
      position: absolute;
      bottom: -40px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        z-index: 999;
        height: 20px;
        cursor: pointer;
      }
    }

  }
}

</style>